import React, { useEffect, useState } from "react";
import classes from "./Toast.module.css";
import images from "../../assets/images";
import Toast from "./Toast";

const SuccessToast = ({ title, message, autoHideDuration, toastKey }) => {
  const { successIcon } = images;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
  }, [toastKey]);

  return (
    <Toast
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      onClose={() => setOpen(false)}
      autoHideDuration={autoHideDuration}
      toastKey={toastKey}
    >
      <div className={`${classes["toast"]} ${classes["success-toast"]}`}>
        <div className={classes["toast-title-container"]}>
          <img
            className={classes["toast-icon"]}
            src={successIcon}
            alt="success"
          />
          <div className={classes["toast-title"]}>{title}</div>
        </div>
        <div className={classes["toast-message"]}>{message}</div>
      </div>
    </Toast>
  );
};

export default SuccessToast;
